/**
 * Veilans PDP — gallery counter, view sync, CTA polish.
 */
(function () {
  function initGalleryChrome(root) {
    const mediaCol = root.querySelector('.product-information__media');
    if (!mediaCol) return;

    const chrome = mediaCol.querySelector('[data-veilans-gallery-chrome]');
    if (!chrome || chrome.dataset.veilansBound) return;
    chrome.dataset.veilansBound = '1';

    const slideshow = mediaCol.querySelector('slideshow-component');
    const counterIndex = chrome.querySelector('[data-gallery-counter-index]');
    const total = Number(chrome.getAttribute('data-media-count') || 1);

    const setActive = (index) => {
      const i = Math.max(0, Math.min(index, total - 1));
      if (counterIndex) counterIndex.textContent = `${i + 1}/${total}`;
      mediaCol.classList.add('veilans-pdp-gallery--transition');
      window.setTimeout(() => mediaCol.classList.remove('veilans-pdp-gallery--transition'), 420);
    };

    if (slideshow) {
      slideshow.addEventListener('slideshow:select', (event) => {
        const index = event?.detail?.index;
        if (typeof index === 'number') setActive(index);
      });
    }

    setActive(0);
  }

  function relabelBuyNow(root) {
    root.querySelectorAll('.shopify-payment-button__button, .accelerated-checkout-button').forEach((el) => {
      if (el.dataset.veilansBuyNow) return;
      el.dataset.veilansBuyNow = '1';
    });
  }

  function init() {
    const roots = document.querySelectorAll('.veilans-pdp, .template-product .product-information');
    roots.forEach((root) => {
      initGalleryChrome(root);
      relabelBuyNow(root);
      watchGallery(root);
    });
  }

  /** Selecting a colour swaps in a new <media-gallery> (with its own chrome); bind it again. */
  function watchGallery(root) {
    const mediaCol = root.querySelector('.product-information__media');
    if (!mediaCol || mediaCol.dataset.veilansWatched) return;
    mediaCol.dataset.veilansWatched = '1';
    new MutationObserver(() => initGalleryChrome(root)).observe(mediaCol, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
